<div id="main-container" class="col-md-4 bannerBg">
  <h1 class="adovacyTitle">{{ mainTitle }}</h1>
</div>
@for (list of lists; track list) {
  <div id="questionLists" class="col-md-10 mt-4">
    <h2>{{ list.title }}</h2>
    <p>
      {{ list.text }}
    </p>
  </div>
}
